import type { AuditAction, ListAuditActionsQuery } from '@bcl/shared';
import { api } from '@/lib/api';

/**
 * Construit la querystring `?key=value&...` à partir des filtres. On laisse
 * de côté toutes les valeurs `undefined` pour ne pas envoyer de clés vides.
 */
function buildQueryString(query: ListAuditActionsQuery): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === '') continue;
    params.set(key, String(value));
  }
  const s = params.toString();
  return s ? `?${s}` : '';
}

export async function listAuditActions(
  query: ListAuditActionsQuery,
): Promise<AuditAction[]> {
  const qs = buildQueryString(query);
  const { data } = await api.get<AuditAction[]>(`/admin/audit${qs}`);
  return data;
}
